export default [
  //Auth Routes
  {
    path: "/auth",
    name: "Auth",
    component: () =>
      import(/* webpackChunkName: "auth" */ "@/views/auth/index.vue"),
    meta: { layout: "auth" },
  },
];
